export default __webpack_public_path__ + "static/identify-dark-ba7923d77205fcee4c5d1a07db0697b8.png";